//import { getField } from 'vuex-map-fields';
export default {
    // getAdminField(state) {
    //     return getField(state.admins);
    // },
    // getClientField(state) {
    //     return getField(state.clients);
    // },
    // getConsultantField(state) {
    //     return getField(state.consultants);
    // }
}
